module.exports = __webpack_public_path__ + "img/pomoc-brak-miejsc.d049139e.png";